import * as algosdk from './main.js';

export * from './main.js';
export default algosdk;
